/* eslint-disable @typescript-eslint/no-explicit-any */
import { loadScript } from '../support/Utils';

type Listener = () => void;
type LatLng = { lat: number; lng: number };

export type LatLngBounds = {
  getCenter: () => LatLng;
  extend: (position: LatLng) => void;
};
export type Map = {
  setCenter: (center: LatLng) => void;
  fitBounds: (bounds: LatLngBounds) => void;
  getZoom: () => number;
  setZoom: (zoom: number) => void;
};
export type Marker = {
  setMap: (map: Map | null | undefined) => void;
  addListener: (name: string, listener: Listener) => void;
};
export type InfoWindow = {
  open: (map: Map, marker: Marker) => void;
  close: () => void;
  addListener: (name: string, listener: Listener) => void;
};
type InfoWindowConfig = {
  content: HTMLElement;
};
type MarkerConfig = {
  position: LatLng;
  map: Map;
};
type MapConfig = {
  zoom?: number;
  center?: LatLng;
  mapTypeControl?: boolean;
  streetViewControl?: boolean;
};
export type Place = {
  place_id: string;
  formatted_address: string;
  geometry: {
    location: {
      lat: () => number;
      lng: () => number;
    };
  };
};
export type Autocomplete = {
  addListener: (name: string, listener: Listener) => void;
  getPlace: () => Place;
};

export type GoogleMap = {
  Marker: {
    new (config: MarkerConfig): Marker;
  };
  InfoWindow: {
    new (config: InfoWindowConfig): InfoWindow;
  };
  Map: {
    new (container: HTMLElement, config: MapConfig): Map;
  };
  LatLngBounds: {
    new (): LatLngBounds;
  };
  places: {
    Autocomplete: {
      new (inputEl: HTMLInputElement): Autocomplete;
    };
  };
};

const API_KEY = 'AIzaSyBGG0Zg-WQSgO35DwXY8gq-tSzQtinrSQE';
const SCRIPT_URI = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&libraries=places`;

let cachedPromise: Promise<GoogleMap> | null | undefined;

export default function loadGoogleMapsAPI(): Promise<GoogleMap> {
  if (cachedPromise) {
    return cachedPromise;
  }
  let promise = loadScript(SCRIPT_URI)
    .then(() => {
      let value: GoogleMap = (global as any).google.maps;
      return value;
    })
    .catch((e) => {
      // If the script fails to load, clear the cached promise so the next
      // call to this function will try again.
      cachedPromise = undefined;
      throw e;
    });
  cachedPromise = promise;
  return promise;
}
